<template>
  <div class="market-map">
    <div v-if="loading" class="market-map__loading">Идет загрузка...</div>

    <div class="market-map__error" v-else-if="error">Не удалось загрузить акции</div>

    <highchart v-else class="market-map__chart" ref="chart" :options="options" :highchart="highcharts" />

    <img
      class="market-map__logo"
      src="../../assets/img/icons/beststocks.svg"
      width="156"
      height="41"
      alt="Beststocks logo"
    />
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";

export default {
  props: {
    options: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    error: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      highcharts: Highcharts
    };
  },
  components: {
    highchart: Chart
  }
};
</script>

<style>
.market-map {
  position: relative;

  height: calc(100vh - 8px);
  padding: 8px 4px 2px;
  display: flex;
  flex-direction: column;

  font-family: "Lab Grotesque", sans-serif;
  font-size: 16px;
  line-height: 1.5;
}

.market-map__loading,
.market-map__error {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.market-map__chart {
  height: calc(100vh - 8px);
  width: 100%;
}

.market-map__logo {
  position: absolute;
  bottom: 22px;
  right: 22px;
}

@media screen and (max-width: 768px) {
  .market-map__logo {
    width: 120px;
    height: auto;
  }
}

.market-map-label {
  position: relative;
  z-index: 2;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  text-align: center;

  color: inherit;
  text-decoration: none;
}

.market-map-parent-label {
  position: relative;
  top: 2px;
  z-index: 3;

  padding: 4px 4px;
  display: block;

  text-overflow: ellipsis;
  text-align: left;
  font-size: 12px;
  overflow: hidden;

  background-color: #333333;
  color: #ffffff;
}

.market-map-tooltip {
  position: relative;
  z-index: 10;

  padding: 10px 10px;
  line-height: 1.4;

  border: 1px solid #eeeff2;
  border-radius: 4px;
  background-color: #ffffff;
}
</style>

